import { useState, useRef, useCallback } from 'react';

export const useDragState = () => {
  const [isDragOver, setIsDragOver] = useState(false);
  const dragCounterRef = useRef(0);

  const incrementDragCounter = useCallback(() => {
    dragCounterRef.current += 1;
    setIsDragOver(true);
  }, []);

  const decrementDragCounter = useCallback(() => {
    dragCounterRef.current -= 1;
    if (dragCounterRef.current <= 0) {
      dragCounterRef.current = 0;
      setIsDragOver(false);
    }
  }, []);

  const resetDragState = useCallback(() => {
    dragCounterRef.current = 0;
    setIsDragOver(false);
  }, []);

  return {
    isDragOver,
    incrementDragCounter,
    decrementDragCounter,
    resetDragState,
  };
};
